/* Footer: menu drawers on phones (open on desktop), menu headings aligned with the brand text, cookie preferences link. */
(() => {
  const mq = window.matchMedia('(max-width: 749px)');
  const setOpen = (menu, open) => {
    const btn = menu.querySelector('.nt-ft__toggle');
    const panel = menu.querySelector('.nt-ft__panel');
    if (!btn || !panel) return;
    btn.setAttribute('aria-expanded', String(open));
    panel.classList.toggle('is-open', open);
    if (mq.matches && !open) panel.setAttribute('inert', ''); else panel.removeAttribute('inert');
  };
  const sync = (root) => {
    root.querySelectorAll('.nt-ft').forEach((ft) => {
      const acc = ft.hasAttribute('data-accordion');
      const first = ft.dataset.firstOpen === 'true';
      ft.querySelectorAll('.nt-ft__menu').forEach((m, i) => setOpen(m, !acc || !mq.matches || (first && i === 0)));
    });
  };
  const cookie = (root) => {
    root.querySelectorAll('.nt-ft__cookie').forEach((btn) => {
      let tries = 0;
      (function check() {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          btn.hidden = false;
          btn.addEventListener('click', () => window.privacyBanner.showPreferences());
        } else if (tries++ < 20) setTimeout(check, 500);
      })();
    });
  };
  /* Desktop: menu headings on the same line as the brand text headings (logo + social icons stay above). */
  const desk = window.matchMedia('(min-width: 990px)');
  let raf = 0;
  const measure = () => {
    raf = 0;
    document.querySelectorAll('.nt-ft[data-align-text]').forEach((ft) => {
      const brandHeading = ft.querySelector('.nt-ft__cols .nt-ft__heading') || ft.querySelector('.nt-ft__cols');
      const menuHeading = ft.querySelector('.nt-ft__menu .nt-ft__heading');
      if (!desk.matches || !brandHeading || !menuHeading) { ft.style.removeProperty('--nt-fm-top'); return; }
      ft.style.setProperty('--nt-fm-top', '0px');
      const bb = brandHeading.getBoundingClientRect();
      const mb = menuHeading.getBoundingClientRect();
      /* Match the vertical centres of the two heading lines (menu headings can use a different size). */
      ft.style.setProperty('--nt-fm-top', Math.max(0, Math.round((bb.top + bb.height / 2) - (mb.top + mb.height / 2))) + 'px');
    });
  };
  const schedule = () => { if (!raf) raf = requestAnimationFrame(measure); };
  desk.addEventListener ? desk.addEventListener('change', schedule) : desk.addListener(schedule);
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.nt-ft[data-accordion] .nt-ft__toggle');
    if (!btn || !mq.matches) return;
    setOpen(btn.closest('.nt-ft__menu'), btn.getAttribute('aria-expanded') !== 'true');
  });
  mq.addEventListener ? mq.addEventListener('change', () => sync(document)) : mq.addListener(() => sync(document));
  document.addEventListener('shopify:section:load', (e) => { sync(e.target); cookie(e.target); schedule(); });
  document.addEventListener('shopify:block:select', (e) => { const m = e.target.closest && e.target.closest('.nt-ft__menu'); if (m && mq.matches) setOpen(m, true); });
  const init = () => { sync(document); cookie(document); schedule(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
